import { render, staticRenderFns } from "./TechVideo.vue?vue&type=template&id=ede0dc7a&"
import script from "./TechVideo.vue?vue&type=script&lang=js&"
export * from "./TechVideo.vue?vue&type=script&lang=js&"
import style0 from "./TechVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports